// Save the values on screen as a named scenario everyone can load. A taken name is refused here,
// beside the box it was typed in, and the dialog stays open to take another.

import { useState } from 'react';

import { saveScenario } from '../api.js';
import Modal from '../ui/Modal.jsx';

export default function SaveScenarioDialog({ modelId, values, onClose, onSaved }) {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSaved(await saveScenario(modelId, name.trim(), values));
    } catch (err) {
      setError(err.fields ? Object.values(err.fields).join(' ') : err.message);
      setBusy(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <form onSubmit={onSubmit}>
        <h3>Save scenario as</h3>
        <label>
          Name
          <input value={name} onChange={(event) => setName(event.target.value)} maxLength={120}
                 autoFocus required />
        </label>
        {error && <p className="error">{error}</p>}
        <menu>
          <button type="button" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" disabled={busy || !name.trim()}>{busy ? 'Saving…' : 'OK'}</button>
        </menu>
      </form>
    </Modal>
  );
}
